import LayerTypes from '../enums/layerTypes';

const CURSOR_CLASS = 'nhs-u-cursor--pointer';
/**
 * CSS selector matching the SVG layer groups that actually represent lots — used both to
 * decide the pointer cursor (below) and, in svgLotInteraction.js, to reject id-bearing
 * elements from unrelated layers (Buildings, Amenity, LotGroup, etc. can carry ids too) that
 * would otherwise false-positive as a lot click.
 */
export const LOT_INTERACTIVE_LAYERS_SELECTOR = [LayerTypes.LotPolygons, LayerTypes.LotNumbers]
  .map((type) => `[data-layer-type="${type}"]`)
  .join(', ');

/**
 * Creates interaction handlers for lot polygon events emitted by the SVG overlay.
 *
 * Pure event delegation — no CSS, no Redux, no business logic.
 * The plugin passes callbacks; this module only wires DOM events to them.
 *
 * @param {object} params
 * @param {Function} params.onLotSelected - Called with lotId when a lot is clicked
 * @param {Function} params.onLotHovered  - Called with lotId when pointer enters a lot
 * @param {Function} params.onLotLeft     - Called when pointer leaves the SVG
 * @param {Function} params.onMapBackgroundClicked - Called when a click misses every lot
 * @returns {{ onSvgReady, onLotEnter, onLotLeave, onLotHover, onLotClick, onBackgroundClick }}
 */
function createLotPolygonInteractionHandlers({ onLotSelected, onLotHovered, onLotLeft, onMapBackgroundClicked }) {
  return {
    onSvgReady(svgElement) {
      svgElement.classList.add('nhs-u-absolute', 'nhs-u-pointer-events--all');
      svgElement.querySelectorAll('path:not([id])').forEach((path) => {
        if (!path.closest('[id]')) {
          path.classList.add('nhs-u-pointer-events--none');
        }
      });
    },
    onLotEnter({ target, svgElement }) {
      svgElement.classList.toggle(CURSOR_CLASS, !!target.closest(LOT_INTERACTIVE_LAYERS_SELECTOR));
    },
    onLotLeave({ svgElement }) {
      svgElement.classList.remove(CURSOR_CLASS);
      onLotLeft();
    },
    onLotHover({ lotId }) {
      onLotHovered(lotId);
    },
    onLotClick({ lotId }) {
      onLotSelected(lotId);
    },
    onBackgroundClick() {
      onMapBackgroundClicked();
    },
  };
}

export default createLotPolygonInteractionHandlers;
